import { Action, Types } from "./moduleContext.actions"

export enum Modules {
  Team = "team",
  PersonalPlanning = "personal_planning",
  Planning = "planning",
  Absences = "absences",
  Templates = "templates",
  Practices = "practices",
  PersonalAbsences = "personal_absences",
  Poc = "poc",
  System = "system",
  Contract = "contracts",
}

export type ModuleContextState = {
  previousModule: Modules | undefined
  currentModule: Modules | undefined
  loading: boolean
}

const initialState: ModuleContextState = {
  previousModule: undefined,
  currentModule: undefined,
  loading: true,
}

export default (state = initialState, action: Action) => {
  switch (action.type) {
    case Types.CHANGE_MODULE:
      return {
        ...state,
        loading: true,
        previousModule: state.currentModule,
      }

    case Types.CHANGE_MODULE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentModule: action.payload.module,
      }

    default:
      return state
  }
}
